<template lang="pug">
v-menu(
  ref="menu"
  v-model="menu"
  :close-on-content-click="false"
  transition="scale-transition"
  offset-y
  max-width="290px"
  min-width="290px"
)
  template(v-slot:activator="{ on }")
    ev-text-field(
      v-model="computedDateFormatted"
      @blur="date = parseDate(value)"
      v-on="on"
      clearable
      v-bind="$attrs"
    )
  v-date-picker(
    flat
    v-model="selected"
    no-title
    @input="menu = false"
    first-day-of-week="1"
    :max="maxDate"
    :min="minDate"
  )
</template>

<script>
import format from 'date-fns/format';

const today = new Date().toISOString().slice(0, 10);

export default {
  name: 'CustomDatePicker',
  props: {
    value: { type: [String, Date], default: () => today },
    min: { type: [String, Date], default: () => '' },
    max: { type: [String, Date], default: () => '' },
  },
  data: () => ({
    menu: null,
    date: null,
  }),

  computed: {
    selected: {
      get() {
        if (!this.value) return '';
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    computedDateFormatted: {
      get() {
        if (!this.value) return '';
        return format(new Date(this.value), 'dd.MM.yyyy');
      },
      set() {},
    },
    minDate() {
      return this.min && this.min.toISOString();
    },
    maxDate() {
      return this.max && this.max.toISOString();
    },
  },

  watch: {
    date() {
      this.value = this.formatDate(this.date);
    },
  },
  created() {
    if (this.max) {
      this.$emit('input', format(new Date(this.max), 'yyyy-MM-dd'));
    }
  },
  methods: {
    formatDate(date) {
      if (!date) {
        return null;
      }
      return date;
    },
    parseDate(date) {
      if (!date) {
        return null;
      }
      return date;
    },
  },
};
</script>
